import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './NotebookList.scss';

import { getState } from '../../reducers/Notebooks/NotebooksReducer';

import NotebookItem from './NotebookItem/NotebookItem';
// import SidebarAd from '../SidebarAd/SidebarAd';

@withRouter
@connect(state => ({
  notebooks: getState(state),
}))
export default class NotebookList extends Component {
  static propTypes = {
    notebooks: PropTypes.object,
  };

  componentWillReceiveProps(nextProps) {
    this.autoLink(nextProps);
  }

  // 自动跳转
  autoLink = (nextProps) => {
    // 先判断path是否已经确定
    const { match: { path } } = nextProps;
    if (!['/notebooks/:nbId', '/notebooks/:nbId/notes/:noteId'].includes(path)) {
      const { notebooks } = nextProps;
      // 判断是否成功拿到数据
      const seq = notebooks.get('seq');
      // 判断是否含有文集
      if (seq.size > 0) {
        this.props.history.replace(`/notebooks/${seq.first()}`);
      }
    }
  };

  getNotebookItems = () => {
    const { notebooks, match } = this.props;
    const entities = notebooks.get('entities');
    const seq = notebooks.get('seq');
    const { params: { nbId } } = match;
    return seq.map((id, index) => (
      <NotebookItem
        key={id}
        index={index}
        preNbId={seq.get(index - 1)}
        nextNbId={seq.get(index + 1)}
        notebook={entities.get(`${id}`)}
        active={+id === +nbId}
      />
    ));
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    const { className } = this.props;
    const listClass = classNames(className, styles['notebook-list']);

    return (
      <ul className={listClass}>
        {this.getNotebookItems()}
        {/* <SidebarAd/> */}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotebookList/NotebookList.js